<td class="patient-name-wrapper">
  <div class="patient-general-wrapper">
    <div class="patient-info-wrapper">
      <msd-avatar class="patient-avatar-image" [text]="initials" [src]="patientAvatarUrl"></msd-avatar>
      <span class="patient-name-text desktop" [class.btn-link]="patientId" (click)="goToPatient()" >{{patientName}}</span>
      <span class="patient-name-text mobile">{{patientName}}</span>
    </div>
    <msd-badge *ngIf="isNew" [text]="'Nouveau'"></msd-badge>
    <!-- <i *ngIf="isClosed" class="icon-btn closed-icon" i-bs name="lock-fill"></i> -->
  </div>
</td>
<td class="subject-wrapper">
  <span class="subject-text">{{subject}}</span>
</td>
<td class="last-activity-wrapper">
  <span class="last-activity-text">{{formattedDate}}</span>
</td>
